<h1 class="table__title">Duplicate Documents</h1>

<ul class="table__control inline-list">
  <li>
    <div class="form-container">
      <section class="custom-check-box-group">
        <mat-checkbox class="custom-check-box" name="ContractAcceptDuplicates" [(ngModel)]="value"
          (change)="formChanged($event)">I confirm that I am
          uploading a duplicate document</mat-checkbox>
        <mat-error *ngIf="!value">You must confirm that you are uploading a duplicate document</mat-error>
      </section>
    </div>
  </li>
</ul>

<div class="table__container">
  <ng-template #noDocuments>
    <h3>No Documents</h3>
  </ng-template>


  <table *ngIf="documents?.length > 0;else noDocuments" class="table__inner" mat-table [dataSource]="dataSource" matSort
    (matSortChange)="applySort($event)">
    <ng-container matColumnDef="ContractDeletedDate">
      <th mat-header-cell mat-sort-header *matHeaderCellDef align="center">
        Icon
      </th>
      <td mat-cell *matCellDef="let element" align="center">

        <mat-icon><img
            [src]="element?.propertiesObj.ContractDeletedDate ? 'assets/images/icon-invalid.svg' : 'assets/images/icon-file.svg'" />
        </mat-icon>

      </td>
    </ng-container>

    <ng-container matColumnDef="Name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
      <td mat-cell *matCellDef="let element">
        {{ element?.propertiesObj.DocumentTitle }}</td>
    </ng-container>

    <ng-container matColumnDef="ContractIdentifier">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Contract ID
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.ContractIdentifier }}</td>
    </ng-container>

    <ng-container matColumnDef="Category">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        Category
      </th>
      <td mat-cell *matCellDef="let element">{{ element?.propertiesObj.Category }}</td>
    </ng-container>



    <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true">
    </tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

</div>
<mat-paginator class="table__pagination" [pageSizeOptions]="[5, 10, 25, 100]" (page)="paged($event)"></mat-paginator>
